var e,
    n = new Promise(function (n) {
  e = n;
});
export { e as done, n as ready };